module.exports = __webpack_public_path__ + "img/Murmeli2.842b49ef.gif";